#@import Booking.Views.Base
#@export Booking.Views.PickerElement

class Booking.Views.PickerElement extends Booking.Views.Base

  events:
    'click': 'select'

  constructor: ->
    Booking.Views.Base.apply this, arguments

  attributes: ->
    'data-bhc': @getPresenter()?.bhc()

  select: ->
    @trigger 'picker:element:select', @model

